import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import styles from './TagSelect.module.css'

interface Props {
  items: Array<{ name: string; id: string }>
  actives: string[]
  toggleLeaf: (id: string) => void
}

/** 当前一行高度为28px */
const HEIGHT = 29

export default function TagSelect({ items, actives, toggleLeaf }: Props) {
  const [show, setShow] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const elRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!elRef.current) return

    if (elRef.current.scrollHeight > HEIGHT) {
      setHasMore(true)
    }
  }, [items])

  return (
    <div className="flex items-start justify-between overflow-hidden">
      <div
        className={classNames('flex items-center flex-wrap gap-2', {
          'h-[28px]': !show,
          'h-auto': show,
        })}
        ref={elRef}
      >
        {items.map((item, index) => {
          return (
            <div
              key={index}
              className={classNames(styles.tag, {
                [styles.tagActive]: actives.includes(item.id),
              })}
              onClick={() => {
                toggleLeaf(item.id)
              }}
            >
              {item.name}
            </div>
          )
        })}
      </div>

      {hasMore && (
        <div
          className={classNames(
            'rounded-full bg-neutral-200 w-10 h-[28px] flex-shrink-0 flex items-center justify-center cursor-pointer ml-2 border-2 border-solid border-neutral-200',
            {
              '!border-neutral-600': show,
            }
          )}
          onClick={() => {
            setShow(!show)
          }}
        >
          <MyIcon
            icon="arrow-down-simple"
            className={classNames('text-[24px]', {
              'rotate-180 text-neutral-600': show,
            })}
          ></MyIcon>
        </div>
      )}
    </div>
  )
}
